import React from "react";
import PropTypes from "prop-types";
import TextFieldGroup from "../../reusable/TextFieldGroup";
import { Link } from "react-router-dom";
import NotificationAlert from "react-notification-alert";
import isEmpty from "lodash/isEmpty";
import Validator from "validator";
import { connect } from "react-redux";
import { contactUs } from "../../modules/actions/authActions";
import { PulseLoader, ClipLoader } from "react-spinners";

function validateInput(data) {
  let errors = {};
  if (Validator.isEmpty(data.name)) {
    errors.name = "Name field is required";
  }
  if (Validator.isEmpty(data.email)) {
    errors.email = "Email field is required";
  }

  if (!Validator.isEmail(data.email)) {
    errors.email = "Enter valid Email ID";
  }
  if (Validator.isEmpty(data.subject)) {
    errors.subject = "Subject field is required";
  }
  if (Validator.isEmpty(data.message)) {
    errors.message = "Message field is required";
  }
  return {
    errors,
    isValid: isEmpty(errors)
  };
}
class ContactContent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      subject: "",
      message: "",
      errors: {},
      successMsg: "",
      isLoading: false,
      invalid: false,
      showingAlert: false,
      tab: "1"
    };
  }

  handleClickShowAlert() {
    this.setState({
      showingAlert: true
    });

    setTimeout(() => {
      this.setState({
        showingAlert: false
      });
    }, 2000);
  }

  setTab(tabId) {
    this.setState({ "tab": tabId });
  }

  _onChange = event => {
    const field = event.target.name;
    const value = event.target.value;
    this.setState({ [field]: value });
  };

  handleContactUs = event => {
    event.preventDefault();
    if (this.isValid()) {
      const { name, email, subject, message } = this.state;

      const contactPayload = {
        name,
        email,
        subject,
        message
      };
      this.setState({ errors: {}, isLoading: true });
      this.props
          .contactUs(contactPayload)
          .then(data => {
            console.log(data);
            if (data.status) {
              this.setState({ isLoading: false });
              this.refs.notify.notificationAlert({
                place: "tc",
                message: (
                    <div>
                      <div>
                        <b>{data.message}</b>
                      </div>
                    </div>
                ),
                type: "success",
                icon: "now-ui-icons ui-1_bell-53",
                autoDismiss: 7
              });
            } else {
              this.setState({ isLoading: false });
              this.refs.notify.notificationAlert({
                place: "tc",
                message: (
                    <div>
                      <div>
                        <b>{data.message}</b>
                      </div>
                    </div>
                ),
                type: "danger",
                icon: "now-ui-icons ui-1_bell-53",
                autoDismiss: 7
              });
            }
          })
          .catch(error => {
            this.setState({ isLoading: false });
            this.refs.notify.notificationAlert({
              place: "tc",
              message: (
                  <div>
                    <div>
                      <b>{error.response.data.message}</b>
                    </div>
                  </div>
              ),
              type: "danger",
              icon: "now-ui-icons ui-1_bell-53",
              autoDismiss: 7
            });
          });
    }
  };

  isValid() {
    const { errors, isValid } = validateInput(this.state);

    if (!isValid) {
      this.setState({ errors });
    }
    return isValid;
  }

  render() {
    const { errors, successMsg, name, email, subject, message } = this.state;
    return (
        <section className="section">
          <div className="container">
            <div className="row">
              <PulseLoader
                  className="sweet-loading"
                  sizeUnit={"px"}
                  size={20}
                  color={"#123abc"}
                  loading={this.state.isLoading}
              />
              <div className="col-lg-12">
                <h1 className="">Let’s work together</h1>
                <div style={{ clear: "both", height: "35px" }} />
              </div>

              <div className="col-lg-12 connect-navi">
                <div className="row">
                  <div className="col-lg-3 uppercase bold600 connect-navi-btn mb-3"><a className={`btn btn-white` + ((this.state.tab == '1') ?  ` active` : "")} onClick={ () => this.setTab(1) }>Affiliate (coming soon)</a></div>
                  <div className="col-lg-3 uppercase bold600 connect-navi-btn mb-3"><a className={`btn btn-white` + ((this.state.tab == '2') ?  ` active` : "")} onClick={ () => this.setTab(2) }>Referral</a></div>
                  {/*<div className="col-lg-3 uppercase bold600 connect-navi-btn mb-3"><a className={`btn btn-white` + ((this.state.tab == '3') ?  ` active` : "")} onClick={ () => this.setTab(3) }>B2B</a></div>*/}
                </div>
              </div>


              {/*
            <div className="col-lg-4">
              <div className="contact_icon_box mt-3 rounded">
                <div className="text-center p-3 m-2 bg-light">
                  <div className="contact-icon text-custom">
                    <i className="pe-7s-map-marker" />
                  </div>
                  <div className="contact-detail mt-3">
                    <h6>Visit Office</h6>
                    <p className="text-muted">
                      560 Sylvan Ave. Englewood Cliffs NJ
                    </p>
                  </div>
                </div>
              </div>
            </div>
            */}
            </div>
            <div className="row mt-4">

              <div className="col-lg-7">
                <div id="video1" className="connect-description mt-5" style={{ display: this.state.tab == '1' ? "block": "none" }}>
                  If you are interested in making money by introducing must-have travel Wifi hotspot device? Sign up for our program and start making commissions on your sales. Once you are approved, we will send you a code to use on your network customers. We offer 10% of all sales you generate using our code.
                  <div style={{ clear: "both", height: "35px" }} />
                  <h3 className="">How to Start?</h3>
                  <div style={{ clear: "both", height: "10px" }} />
                  <ol className="list-inside font19">
                    <li>Submit the form (will be provided to you once approved)</li>
                    <li>Use the code when submit</li>
                    <li>Promote and share on your social network</li>
                    <li>Monthly commission payment</li>
                  </ol>
                </div>
                <div id="video2" className="connect-description mt-5" style={{ display: this.state.tab == '2' ? "block": "none" }}>
                  <h3 className="">Introduce Friends and Family</h3>
                  <div style={{ clear: "both", height: "25px" }} />
                  Are you enjoying your device so far? You can earn extra data referring your friends and family.<br/><br/>
                  Referring your friends is very easy, have them enter your code when they place an order. This is for device purchase only.<br/><br/>
                  Once you submit the form, we will give you a code your friends and family can use. Spread the words and your MightyWifi experience.
                </div>
                <div id="video3" className="connect-description mt-5" style={{ display: this.state.tab == '3' ? "block": "none" }}>
                  <h3 className="">Business to Business</h3>
                  <div style={{ clear: "both", height: "25px" }} />
                  Still spending tons of money on employee roaming charges and uncertain data charges from carriers? Prepaid global data plans are your answers. We currently provide internet data packages over 200 countries. Pay as you go with no contract data packages. We also rent multiple wifi devices for events and or purchase devices for remote working employees globally. No sim cards or activation fees. You can instantly recharge the data using our state of art APP program.
                  <br/><br/>
                  <strong>Contact Us Today</strong><br/>
                  Fill out the form, and we will get back to you without delay.<br/>
                  Start saving money today.
                  <br/><br/>
                  <strong>Support@mightywifi.net</strong> or <strong>201 731 3839</strong><br/>
                  (M to F, 9 AM to 6 PM Eastern Time)
                </div>
              </div>

              <div className="col-lg-5">
                <div className="contact_form mt-3">
                  <NotificationAlert ref="notify" />
                  <form onSubmit={this.handleContactUs}>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group mt-3">
                          <input
                              placeholder="Name"
                              className="form-control"
                              type="text"
                              onChange={this._onChange}
                              value={name}
                              name="name"
                          />
                          {errors.name && (
                              <span className="error-color-dash">
                          {errors.name}
                        </span>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group mt-3">
                          <input
                              placeholder="Email Address"
                              className="form-control"
                              type="text"
                              onChange={this._onChange}
                              value={email}
                              name="email"
                          />
                          {errors.email && (
                              <span className="error-color-dash">
                          {errors.email}
                        </span>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group mt-3">
                          <input
                              placeholder="Subject"
                              className="form-control"
                              type="text"
                              onChange={this._onChange}
                              value={subject}
                              name="subject"
                          />
                          {errors.subject && (
                              <span className="error-color-dash">
                          {errors.subject}
                        </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group mt-3">
                      <textarea
                          name="comments"
                          id="comments"
                          rows="4"
                          onChange={this._onChange}
                          value={message}
                          name="message"
                          className="form-control"
                          placeholder="Message"
                      />
                          {errors.message && (
                              <span className="error-color-dash">
                          {errors.message}
                        </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div style={{ clear: "both", height: "30px" }} />
                    <div className="row">
                      <div className="col-lg-12">
                        <input
                            type="submit"
                            className="btn btn-custom btn-orange"
                            value="Send Message"
                        />
                      </div>
                    </div>
                  </form>
                </div>
              </div>

            </div>
          </div>
        </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}
export default connect(
    mapStateToProps,
    {
      contactUs
    }
)(ContactContent);



// WEBPACK FOOTER //
// ./src/pages/connect/ConnectContent.js